import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};
//
export const createBanner = async (formValues) => {
  const formData = new FormData();
  formData.append("BannerTitle", formValues.BannerTitle);
  formData.append("BannerLink", formValues.BannerLink);
  formData.append("Published", formValues.Published.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder);

  if (formValues.MobileImageFile) {
    formData.append("MobileImageFile", formValues.MobileImageFile);
  } else {
    formData.append("MobileImageFile", null);
  }

  if (formValues.DesktopImageFile) {
    formData.append("DesktopImageFile", formValues.DesktopImageFile);
  } else {
    formData.append("DesktopImageFile", null);
  }
  const response = await axiosInstance.post("banner", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};
export const updateBanner = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("BannerTitle", formValues.BannerTitle);
  formData.append("BannerLink", formValues.BannerLink);
  formData.append("Published", formValues.Published.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder);

  if (formValues.MobileImageFile) {
    formData.append("MobileImageFile", formValues.MobileImageFile);
  } else {
    formData.append("MobileImageFile", null);
  }

  if (formValues.DesktopImageFile) {
    formData.append("DesktopImageFile", formValues.DesktopImageFile);
  } else {
    formData.append("DesktopImageFile", null);
  }
  const response = await axiosInstance.put("banner", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const fetchBanners = async () => {
  const response = await axiosInstance.get("banner", { headers });
  return response.data;
};

export const fetchBannerById = async (id) => {
  const response = await axiosInstance.get(`banner/${id}`, {
    headers,
  });
  return response.data;
};

export const publishBanner = async (id) => {
  return await await axiosInstance.patch(`banner/${id}/publish`, {
    headers,
  });
};

export const unPublishBanner = async (id) => {
  return await await axiosInstance.patch(`banner/${id}/unpublish`, {
    headers,
  });
};

export const deleteBanner = async (id) => {
  return await axiosInstance.delete(`banner/${id}`, { headers });
};
